var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"nav"}},[(_vm.isLoggedIn)?_c('span',[_c('a',{on:{"click":_vm.logout}},[_vm._v("Logout")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }